import { red } from '@material-ui/core/colors'
import { createMuiTheme } from '@material-ui/core/styles'

// A custom theme for this app
const theme = createMuiTheme({
  themeName: 'ARIA Technologies theme',
  palette: {
    primary: {
      // main: '#556cd6',
      main: '#3ba4b3'
    },
    secondary: {
      // main: '#19857b',
      main: '#84b61e'
    },
    error: {
      main: red.A400
    },
    background: {
      default: '#fff'
    }
  }
})

export default theme
